module.exports = __webpack_public_path__ + "static/media/Raleway-VariableFont_wght.3b5635ac.ttf";